module.exports = "fonts/noto-sans-jp-v28-latin-300.woff2";